import ForgotPasswordForm from "components/Authentication/ForgotPassword/ForgotPasswordForm/ForgotPasswordForm";
import classes from "./ForgotPassword.module.css";
import clsx from "clsx";
import SetNewPassword from "components/Authentication/ForgotPassword/SetNewPassword/SetNewPassword";
import { useState } from "react";
import PasswordChanged from "components/Authentication/SuccessContainer/SuccessContainer";

const ForgotPassword = () => {
  const [step, setStep] = useState(1);
  return (
    <main className={clsx(classes.mainWrapper, "container")}>
      {step === 1 && <ForgotPasswordForm setStep={setStep} />}
      {step === 2 && <SetNewPassword setStep={setStep} />}{" "}
      {step === 3 && (
        <PasswordChanged
          heading="Account Created!"
          info="Thank you for signing up! We’ve sent a verification link to your email. Please check your email and verify to activate your account."
          buttonText="Go to Dashboard"
          to="/dashboard"
        />
      )}
    </main>
  );
};
export default ForgotPassword;
